var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cxs from 'cxs';
import Theme from 'Theme';
import { T, t } from 'helpers/i18n';
import { Input } from 'elements';
import { Col, FormGroup, Input as InputRS, Label as LabelRS } from 'reactstrap';
var FieldLabel = /** @class */ (function (_super) {
    __extends(FieldLabel, _super);
    function FieldLabel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (event) {
            // console.log('FieldInput- handleChange', event.target.value)
            _this.props.onChange(_this.props.name, event.target.value, _this.props.column);
        };
        return _this;
    }
    FieldLabel.prototype.render = function () {
        var _a = this.props, name = _a.name, type = _a.type, value = _a.value, required = _a.required, onChange = _a.onChange, column = _a.column, reactstrap = _a.reactstrap, props = __rest(_a, ["name", "type", "value", "required", "onChange", "column", "reactstrap"]);
        if (reactstrap) {
            return (React.createElement(Col, { xl: 4, md: 6, sm: 12 },
                React.createElement(FormGroup, null,
                    React.createElement(LabelRS, { for: name }, T(name)),
                    React.createElement(InputRS, { value: value, id: name, disabled: true }))));
        }
        return (React.createElement(Input, __assign({ disabled: true }, props, { label: t(column ? column : name) + (required ? '*' : ''), type: type, value: value, className: className, onChange: this.handleChange })));
    };
    return FieldLabel;
}(Component));
export default FieldLabel;
var className = cxs({
    padding: Theme.size.space[1]
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/FieldLabel.tsx
// module id = 959
// module chunks = 0